import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;

if (!apiKey) {
  console.error('API Key not found. Please check your .env file and make sure REACT_APP_API_KEY is set.');
}

// Create axios instance with default config
const api = axios.create({
  baseURL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to add apikey to all requests
api.interceptors.request.use((config) => {
  const separator = config.url.includes('?') ? '&' : '?';
  config.url = `${config.url}${separator}apikey=${apiKey}`;
  return config;
});

// Add response interceptor to handle common response processing
api.interceptors.response.use(
  (response) => {
    // axios automatically parses JSON responses, so usually no need to parse manually
    // Just return response as it is
    return response;
  },
  (error) => {
    console.error('API request failed:', error);
    return Promise.reject(error);
  }
);

export { api };
